module.exports = __webpack_public_path__ + "static/media/connected.3c408524.png";